import { render, staticRenderFns } from "./hospitalservice.vue?vue&type=template&id=4d905971"
import script from "./hospitalservice.vue?vue&type=script&lang=js"
export * from "./hospitalservice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports